const LOCAL_STORAGE_KEY_PREFIX = 'layout-sync-on';
const listeners = new Set();

const getStorageKey = () => {
    const layoutId = window.layoutId
        || document.querySelector('#template-group-preview')?.getAttribute('data-layout-id');

    return layoutId ? `${LOCAL_STORAGE_KEY_PREFIX}:${layoutId}` : LOCAL_STORAGE_KEY_PREFIX;
};

export const isSyncLayoutOn = () => localStorage.getItem(getStorageKey()) === 'true';

export const setSyncLayoutOn = (value) => {
    localStorage.setItem(getStorageKey(), !!value);
    listeners.forEach(listener => listener(!!value));
};

export const onSyncLayoutChange = (listener) => {
    listeners.add(listener);

    return () => listeners.delete(listener);
};
